export default __webpack_public_path__ + "static/media/moon-bg-smm.8151c9e6.png";